import * as mod from 'prop-types';
if (false) {
  module.exports = mod.default;
} else {
  module.exports = mod;
}